import { useLocation } from '@reach/router';
import React from 'react';
import { getUserMatchesAction, showMatchInbox, showUserMessages } from '../../../app/redux/actions/userMatchActions';
import { useAppDispatch, useAppSelector } from '../../../app/redux/hooks';
import UserMatchSlideOver from './UserMatchSlideOver';

const UserMatches = () => {
  const dispatch = useAppDispatch();
  const showMessages = useAppSelector((state) => state.matches?.showMessages);
  const { user, isSignedIn } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const showMatches = params.get('showMatches') !== null;

  const handleOpenSlideOver = (status: boolean) => {
    dispatch(showUserMessages(status));
    dispatch(showMatchInbox(true));
  };

  React.useEffect(() => {
    if (isSignedIn && showMatches) {
      handleOpenSlideOver(true);
    }
  }, []);

  const localStorageInitialCount = `MatchesShowIntro_${user?.id}`;
  React.useEffect(() => {
    (async () => {
      await dispatch(getUserMatchesAction());
    })();
  }, []);

  if (typeof localStorage !== 'undefined') {
    if (showMessages) {
      const introCount = user ? parseInt(localStorage.getItem(localStorageInitialCount) ?? '0') : 0;
      if (introCount < 2) {
        localStorage.setItem(localStorageInitialCount, `${introCount + 1}`);
      }
    }
  }
  return <UserMatchSlideOver open={showMessages} setOpen={handleOpenSlideOver} />;
};

export default UserMatches;
